export default __webpack_public_path__ + "static/media/green-save-icon.0fc07254.svg";